<div class="form-title-container">
  <h3>Datos de escritura</h3>
</div>

<div class="columns is-multiline is-vcentered" [formGroup]="store.form">
  <div class="column is-4 form-container">
    <span class="label">Fecha de Escritura</span>
    <p-calendar
      [iconDisplay]="'input'"
      dateFormat="dd/mm/yy"
      dataType="date"
      [showIcon]="true"
      inputId="deedDate"
      formControlName="deedDate"
    />
  </div>

  <div class="column is-4 form-container">
    <span class="label">Concepto de escritura</span>
    <input
      class="search-input"
      type="text"
      pInputText
      formControlName="deedConcept"
    />
  </div>

  <div class="column is-4 form-container">
    <span class="label">Notario</span>
    <input
      class="search-input"
      type="text"
      pInputText
      formControlName="notary"
    />
  </div>

  <div class="column is-4 form-container">
    <span class="label">Protocolo</span>
    <input
      class="search-input"
      type="text"
      pInputText
      formControlName="protocol"
    />
  </div>

  <div class="column is-4 form-container">
    <span class="label">Provincia registro mercantil</span>
    <input
      class="search-input"
      type="text"
      pInputText
      formControlName="mercantileRegistryProvince"
    />
  </div>

  <div class="column is-4 form-container">
    <span class="label">Fecha inscripción</span>
    <p-calendar
      [iconDisplay]="'input'"
      dateFormat="dd/mm/yy"
      dataType="date"
      [showIcon]="true"
      inputId="registrationDate"
      formControlName="registrationDate"
    />
  </div>

  <div class="column is-4 form-container">
    <span class="label">Tomo</span>
    <input class="search-input" type="text" pInputText formControlName="tome" />
  </div>

  <div class="column is-4 form-container">
    <span class="label">Folio</span>
    <input
      class="search-input"
      type="text"
      pInputText
      formControlName="folio"
    />
  </div>

  <div class="column is-4 form-container">
    <span class="label">Hoja</span>
    <input
      class="search-input"
      type="text"
      pInputText
      formControlName="sheet"
    />
  </div>

  <div class="column is-4 form-container">
    <span class="label">Sección</span>
    <input
      class="search-input"
      type="text"
      pInputText
      formControlName="section"
    />
  </div>

  <div class="column is-4 form-container">
    <span class="label">Libro</span>
    <input class="search-input" type="text" pInputText formControlName="book" />
  </div>

  <div class="column is-4 form-container">
    <span class="label">Nº inscripción</span>
    <input
      class="search-input"
      type="text"
      pInputText
      formControlName="inscriptionNumber"
    />
  </div>
</div>

<div class="form-title-container">
  <h3>Objeto Social</h3>
</div>
<div class="columns is-multiline" [formGroup]="store.form">
  <div class="column is-4 form-container">
    <span class="label">Código CNAE</span>
    <p-dropdown
      [options]="store.cnaeCodes()"
      optionLabel="code"
      optionValue="code"
      placeholder="Seleccionar código CNAE"
      formControlName="cnaeCode"
      [filter]="true"
      filterBy="code,title"
      [emptyFilterMessage]="'No se encontraron resultados'"
    >
      <ng-template let-option pTemplate="item">
        {{ option.code }} - {{ option.title }}
      </ng-template>
      <ng-template let-selected pTemplate="selectedItem">
        {{ selected?.code }} - {{ selected?.title }}
      </ng-template>
    </p-dropdown>
  </div>
  <div class="column is-8 form-container">
    <span class="label">Objeto Social</span>
    <textarea
      type="text"
      class="text-input-area padding-4"
       style="min-height: 5rem;"
      pInputText
      formControlName="corporateName"
    ></textarea>
  </div>
</div>
